import { render, staticRenderFns } from "./PhoneCallButton.vue?vue&type=template&id=28964aa0&scoped=true"
import script from "./PhoneCallButton.vue?vue&type=script&lang=js"
export * from "./PhoneCallButton.vue?vue&type=script&lang=js"
import style0 from "./PhoneCallButton.vue?vue&type=style&index=0&id=28964aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28964aa0",
  null
  
)

export default component.exports